var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "groupbuy-list"
  }, [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'MainGroupbuyingsList'
      }
    }
  }, [_vm._v("總公司團購管理")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("顧客訂單查詢")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('div', {
    staticClass: "col-6 d-flex align-items-center"
  }, [_c('h4', {
    staticClass: "mb-2 mb-xl-0 mr-2 font-weight-bold"
  }, [_vm._v("顧客訂單查詢")])]), _c('div', {
    staticClass: "\n          col-6\n          d-flex\n          justify-content-end\n          align-items-start align-items-xl-center\n        "
  })]), _c('div', {
    staticClass: "d-flex flex-wrap mb-3 justify-content-end"
  }, [_c('div', {
    staticClass: "row-searchbar d-flex mb-2 mb-md-0 mr-md-2"
  }, [_c('b-form-select', {
    staticClass: "mr-2",
    staticStyle: {
      "width": "120px",
      "height": "45px"
    },
    attrs: {
      "options": _vm.options
    },
    model: {
      value: _vm.query.keyword_type,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword_type", $$v);
      },
      expression: "query.keyword_type"
    }
  }), _c('div', {
    staticClass: "w-100"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "可輸入 手機號碼/會員卡號/訂單編號 查詢"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getPoyaGroupbuyingOrders.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  })], 1)], 1), _c('b-button', {
    on: {
      "click": _vm.getPoyaGroupbuyingOrders
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1), _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.groupbuyingOrders,
      "fields": _vm.fields,
      "sort-by": _vm.sortBy,
      "busy": _vm.isFetchGroupbuyingOrders
    },
    on: {
      "update:sortBy": function updateSortBy($event) {
        _vm.sortBy = $event;
      },
      "update:sort-by": function updateSortBy($event) {
        _vm.sortBy = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "cell(order_number)",
      fn: function fn(data) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'GroupbuyingsDetail',
              params: {
                groupbuyID: data.item.groupbuying_id
              }
            }
          }
        }, [_vm._v(" " + _vm._s(data.item.order_number) + " ")])];
      }
    }, {
      key: "cell(quantity)",
      fn: function fn(data) {
        return [_vm.displayEdit(data.item) ? _c('a', {
          attrs: {
            "href": ""
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.handleQuantity(data.item);
            }
          }
        }, [_vm._v(" " + _vm._s(data.item.quantity) + " ")]) : _c('span', [_vm._v(_vm._s(data.item.quantity))])];
      }
    }, {
      key: "cell(cancel)",
      fn: function fn(data) {
        return [_vm.displayCancel(data.item) ? _c('b-button', {
          attrs: {
            "href": "",
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.handleCancelOrder(data.item);
            }
          }
        }, [_vm._v("取消")]) : _vm._e()];
      }
    }, {
      key: "cell(status_label)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(data.item.status_label) + " "), false && data.item.order.cancel_reason ? [_c('BIconQuestionCircle', {
          attrs: {
            "id": "popover-tips-".concat(data.item.id)
          }
        }), _c('b-popover', {
          attrs: {
            "target": "popover-tips-".concat(data.item.id),
            "triggers": "hover focus click"
          }
        }, [_c('div', {
          staticClass: "text-left"
        }, [_vm._v(" " + _vm._s(data.item.order.cancel_reason) + " ")])])] : _vm._e()];
      }
    }])
  }), _vm.editQuantityData ? _c('GroupbuyingsQuantityModal', {
    attrs: {
      "show": _vm.isOpenQuantityModal,
      "data": _vm.editQuantityData,
      "groupbuying": _vm.editQuantityData.groupbuying,
      "groupbuyingNumber": _vm.editQuantityData.groupbuying.groupbuying_number
    },
    on: {
      "update:show": function updateShow($event) {
        _vm.isOpenQuantityModal = $event;
      },
      "updated": function updated($event) {
        return _vm.getPoyaGroupbuyingOrders();
      }
    }
  }) : _vm._e(), _c('div', {
    staticClass: "\n        d-flex\n        justify-content-center\n        align-items-center\n        flex-column flex-md-row\n      ",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('b-pagination', {
    staticClass: "separated mb-2 mb-md-0",
    attrs: {
      "total-rows": _vm.total,
      "per-page": _vm.query.per_page,
      "aria-controls": "groupbuyList"
    },
    on: {
      "change": _vm.handleChangePage
    },
    model: {
      value: _vm.query.page,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "page", $$v);
      },
      expression: "query.page"
    }
  }), _c('div', {
    staticClass: "ml-2"
  }, [_vm._v(" 每頁顯示數量"), _c('b-form-select', {
    staticClass: "ml-2",
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "options": _vm.perPageOptions
    },
    on: {
      "change": _vm.handleChangePage
    },
    model: {
      value: _vm.query.per_page,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "per_page", $$v);
      },
      expression: "query.per_page"
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }